import { render, staticRenderFns } from "./ItemsPerPage.vue?vue&type=template&id=189db0fa&scoped=true"
import script from "./ItemsPerPage.vue?vue&type=script&lang=js"
export * from "./ItemsPerPage.vue?vue&type=script&lang=js"
import style0 from "./ItemsPerPage.vue?vue&type=style&index=0&id=189db0fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189db0fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189db0fa')) {
      api.createRecord('189db0fa', component.options)
    } else {
      api.reload('189db0fa', component.options)
    }
    module.hot.accept("./ItemsPerPage.vue?vue&type=template&id=189db0fa&scoped=true", function () {
      api.rerender('189db0fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-datatable/datatable-components/ItemsPerPage.vue"
export default component.exports